(function ($, Cobalt, undefined) {
    Cobalt.Collapse = {
        initialize: function () {
            return;
            var anchor = $("div.expand-collapse").find("a#collapse-link");
            anchor.click(function () {
                var collapseable = $(".expand-collapse .collapseable");
                if ($(this).hasClass("collapse")) {
                    collapseable.hide();
                    $(this).removeClass("collapse");
                    $(this).addClass("expand");
                }
                else if ($(this).hasClass("expand")) {
                    collapseable.show();
                    $(this).removeClass("expand");
                    $(this).addClass("collapse");
                }
                return false;
            });
        }
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Collapse.js